import React from 'react';
import AutocompleteInput from "../common/input/AutocompleteInput";
import { getCityOrZip } from "../../api/typeaheadApi";
import * as Tools from "../../helpers/Tools";
import { logUI } from "../../api/andyliticsApi";

const USE_CURRENT_LOCATION = 'Current Location';

class UrgentCareZipCode extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            cItems: [],
            cityZipLoading: false,
            cityZipNoResults: false,
            cityInvalid: false,
            canEnableContinueButton: false,
            isGeoLocation: true
        };
        this.cTime = 0;
        this.loadCityZipTypeahead = this.loadCityZipTypeahead.bind(this);
        this.setCurrentLocationAsCityorZip = this.setCurrentLocationAsCityorZip.bind(this);
        this.redirectToFindCare = this.redirectToFindCare.bind(this);
    }

    componentDidMount() {
        logUI("MBHWeb.UI.UrgentCareZipCode.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.geoLocationError !== undefined && this.props.geoLocationError !== "" && this.props.geoLocationError !== prevProps.geoLocationError) {
            this.setState({ isGeoLocation: this.props.geoLocationError ? false : true });
        }
        else if (this.props.geoLocationError === "" && this.props.geoLocationError !== prevProps.geoLocationError)
            this.setState({ isGeoLocation: true });
    }

    loadCityZipTypeahead(val) {
        if (this.state.cityZipLoading === false) {
            this.setState({ cityZipLoading: true });
            if (val !== "") {
                let dt = new Date();
                getCityOrZip({ filter: val }, dt.valueOf())
                    .then(json => {
                        if (this.cTime < json.timestamp) {
                            this.cTime = json.timestamp;
                            let items = [];
                            json = json.results;
                            if (json) {
                                for (var term in json) {
                                    items.push({ id: json[term].zip_city, label: json[term].zip_city });
                                }
                            }
                            this.setState({ cItems: items, cityZipLoading: false, cityZipNoResults: !(items.length > 0) });
                        }
                    });
            }
            else {
                this.setState({ cityZipLoading: false });
            }
        }
    }

    setCurrentLocationAsCityorZip() {
        this.props.getGeoLocation();
        this.props.setCityZip(USE_CURRENT_LOCATION);
    }    

    redirectToFindCare(e) {
        e.preventDefault();
        const { isFromVideoVisitPage } = this.props;
        const userlocation = this.props.cityZip ? `&location=${this.props.cityZip}` : "";
        const findcareSearchParms = isFromVideoVisitPage ? `?${userlocation}` : `?isUrgentCare=true${userlocation}`;
        this.props.history.push({
            pathname: '/findcare',
            state: { findNewDoctor: isFromVideoVisitPage ? true : false },
            searchParms: findcareSearchParms
        });       
    }

    render() {               
        let useCurrentLocation = <div className='use-current-loc-dropdown'>Use current location</div>;
        const isCurrentLocation = (!this.props.currentLat || !this.props.currentLong || this.props.currentLat == null || this.props.currentLong == null) ? false : true;        
        let cityZip = this.props.cityZip === USE_CURRENT_LOCATION && isCurrentLocation ? USE_CURRENT_LOCATION : (this.props.cityZip === USE_CURRENT_LOCATION && !isCurrentLocation) ? '' : this.props.cityZip;
        const isGeoCurrentLocationDisabled = this.props.cityZip === USE_CURRENT_LOCATION && (cityZip === '');
        const formValid = this.props.cityZip && !this.state.cityInvalid && !isGeoCurrentLocationDisabled;
        
        return (
            <div className="col-12">
                <form className="row urgent-care-zip-form" onSubmit={this.redirectToFindCare}>
                    <div className="col-lg-12 form-group minimal-style">
                            <AutocompleteInput value={cityZip} loading={this.state.cityZipLoading}
                                placeholder="City or Zip" prependIcon="icon-location" selectOnBlur
                                itemList={this.state.cItems} noResults={this.state.cityZipNoResults}
                                    onChange={(e, value) => { this.loadCityZipTypeahead(value); this.props.setCityZip(value); }}
                                onSelect={(val) => this.props.setCityZip(val)} onClickPreOpen={this.setCurrentLocationAsCityorZip}
                                isInvalid={(invalid) => this.setState({ cityInvalid: invalid })}                                
                                inputErrorMsg="Select from the drop down."
                                validTerm="Current Location"
                                preOpen={this.state.isGeoLocation ? useCurrentLocation : null}
                            />
                        {isGeoCurrentLocationDisabled && this.props.geoLocationError &&
                            <div className="geo-location-error-msg">{this.props.geoLocationError}</div>
                        }
                    </div>
                    <div className="col-lg-12 form-group">
                        <button 
                         type="submit" 
                         disabled={!formValid} 
                         className="btn btn-primary">CONTINUE</button>
                    </div>
                </form>
            </div>);
    }
}
export default UrgentCareZipCode;